import { render, staticRenderFns } from "./RsaPazienteMovimentiContabiliListComponent.vue?vue&type=template&id=ce1b38ce"
import script from "./RsaPazienteMovimentiContabiliListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteMovimentiContabiliListComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazienteMovimentiContabiliListComponent.vue?vue&type=style&index=0&id=ce1b38ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports